export interface Response {
    lengthValid: boolean
    upperValid: boolean
    lowerValid: boolean
    numberValid: boolean
    upperOrAndLower: boolean
    specialCharValid: boolean
    numberOrAndSpecialChar: boolean
    isSequencial: boolean
}

class PasswordValidator {
    private checkLength = (password?: string): boolean => (password ? password.length >= 8 : false)

    private checkUpperCase = (password?: string): boolean => {
        const exp = RegExp(/[A-ZÇ]+/g)
        return password ? exp.test(password) : false
    }

    private checkLowerCase = (password?: string): boolean => {
        const exp = RegExp(/[a-zç]+/g)
        return password ? exp.test(password) : false
    }

    private checkSequencial = (password: string) => IsSequential(password)

    private checkNumber = (password?: string): boolean => {
        const exp = RegExp(/\d+/g)
        return password ? exp.test(password) : false
    }

    private checkSpecialChar = (password?: string): boolean => {
        const exp = RegExp(/[!@#$%&*+=?<>()\-[\]{}/|:;.,_]/gi)
        return password ? exp.test(password) : false
    }

    validate = (password?: string): Response => {
        password = password?.replace(/\s+/g, '')
        const lengthValid = this.checkLength(password)
        const upperValid = this.checkUpperCase(password)
        const lowerValid = this.checkLowerCase(password)
        const isSequencial = this.checkLowerCase(password)
        const numberValid = this.checkNumber(password)
        const specialCharValid = this.checkSpecialChar(password)

        const upperOrAndLower = lowerValid || upperValid
        const numberOrAndSpecialChar = numberValid || specialCharValid

        return {
            lengthValid,
            upperValid,
            lowerValid,
            isSequencial,
            numberValid,
            upperOrAndLower,
            specialCharValid,
            numberOrAndSpecialChar,
        }
    }
}

export default PasswordValidator
const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
// eslint-disable-next-line no-sparse-arrays
const letters = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    ,
]

const isSequential = (char1: string, char2: string, char3: string) => {
    if (numbers.indexOf(String(char1)) !== -1) {
        const first = numbers.indexOf(String(char1))
        const second = numbers.indexOf(String(char2))
        const third = numbers.indexOf(String(char3))

        if (first === second - 1 && second === third - 1) {
            return true
        }
    } else if (letters.indexOf(String(char1).toLowerCase()) !== -1) {
        const first = letters.indexOf(String(char1).toLowerCase())
        const second = letters.indexOf(String(char2).toLowerCase())
        const third = letters.indexOf(String(char3).toLowerCase())

        if (first === second - 1 && second === third - 1) {
            return true
        }
    }
    return false
}

export const IsSequential = (password: string) => {
    let response = false
    const chars = password.split('')
    for (let i = 0; i < chars.length - 2; i++) {
        response = isSequential(chars[i], chars[i + 1], chars[i + 2])
        if (response) {
            break
        }
    }
    return response
}

export const WEAK_PASSWORD_ERROR =
    'Para continuar, siga os requisitos acima para criar uma senha com no mínimo nível médio de segurança'
